import { NgModule } from "@angular/core";
import { MessageCenterRoutingModule } from "./message-center-routing.module";
import { MessageListComponent } from "./pages/message-list/message-list.component";
import { MessageDetailComponent } from "./pages/message-detail/message-detail.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@app/shared";
import { InboxMessageDetailComponent } from './pages/inbox-message-detail/inbox-message-detail.component';

@NgModule({
  declarations: [
    MessageListComponent,
    MessageDetailComponent,
    InboxMessageDetailComponent,
  ],
  imports: [MessageCenterRoutingModule, CommonModule, SharedModule],
})
export class MessageCenterModule {}
